import { toast } from "react-toastify";
import { _single, _WorkActivity } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"
import { ListMenu } from "../../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { InputDate } from "../../theme/Input/InputDate";
import { SelectWorkActivityStatuses } from "../WorkActivityStatuses/SelectWorkActivityStatuses";
import { SelectWorkActivityPriority } from "../WorkActivityPriority/SelectWorkActivityPriority";
import { SelectWorkActivityType } from "../WorkActivityType/SelectWorkActivityType";
import { SelectWorkActivityTaskType } from "../WorkActivityTaskType/SelectWorkActivityTaskType";
import { useEffect, useState } from "react";
import { AccountEditor } from "../../editor/AccountEditor";
import usePaginator from "../../theme/Component/usePaginator";
import { WorkActivityRelationGroup } from "./WorkActivityRelationGroup/WorkActivityGroupRelation";
import { WorkActivitySubtask } from "./WorkActivitySubtask/WorkActivitySubtask";
import { WorkActivityNotes } from "./WorkActivityNotes/WorkActivityNotes";
import { SelectWorkActivityGroup } from "../WorkActivityGroup/SelectWorkActivityGroup";
import { SelectWorkActivityGroupUserByIDAccount } from "../WorkActivityGroup/WorkActivityGroupUser/SelectWorkActivityGroupUserByIDAccount";
import { SelectProject } from "../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { EditorSprint } from "../Sprint/EditorSprint";
import { BasicButton } from "../../theme/Component/BasicButton";

type Filters = {
    IDProject?: number;
    IDSprint?: number;
    IDWorkActivityPriority?: number;
    IDWorkActivityType?: number;
    IDWorkActivityTaskType?: number;
    IDWorkActivityStatuses?: number;
    IDEmployee?: number;
}

export const WorkActivity = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivity)
    const paginador = usePaginator();
    const [filters, setFilters] = useState<Partial<Filters>>({});
    const [appliedFilters, setAppliedFilters] = useState<Partial<Filters>>({});

    const modal = useModal("", MODAL_LG);
    const modalSubWorks = useModal("", MODAL_LG);
    const modalNotes = useModal("", MODAL_LG);
    const modalC = useModal("Eliminar Tarea", MODAL_SM)

    useEffect(() => {
        getLista();
    }, [paginador.page]);

    const renderSubtaskInfo = (task: any) => {
        if (task.DataBeanProperties.TotalSubtasks) {
            const render =
                ` 
            <div>            
            <strong>Procentaje de Finalización: </strong><small>%${task.DataBeanProperties.ProgressPercent ?? 0}</small><br />
            <strong>${task.DataBeanProperties.DoneSubtasks}</strong><small> de </small><strong>${task.DataBeanProperties.TotalSubtasks}</strong><small> subtareas completadas</small><br />            
            </div>
            `
            return render;
        } else {
            return "No Tiene Sub-Tareas";
        }
    }

    const renderGroupsListInfo = (groups: any[]) => {
        if (groups.length > 0) {
            const items = groups
                .map(group => `<li>${group}</li>`)
                .join("");

            return `<ul>${items}</ul>`;
        } else {
            return "N/P";
        }
    }

    const getLista = (nextFilters: Partial<Filters> = appliedFilters, page: number = paginador.page) => {
        let props: any = {
            State: 1
        }

        Object.entries(nextFilters).forEach(([key, value]) => {
            if (value) {
                props[key] = value;
            }
        });

        instance.getWorkActivityRender(page, 15, props).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                resp.List.forEach(element => {
                    element.DataBeanProperties.EntityActivity = `${element.DataBeanProperties.WorkActivityCode ?? "N/P"}` + " " + `${element.DataBeanProperties.Name ?? "N/P"}`;
                    element.DataBeanProperties.EmployeEntity = element.DataBeanProperties.IDEmployee ? `${element.DataBeanProperties.AccountNit ?? "S/D"} - ${element.DataBeanProperties.AccountFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.ReporterEntity = element.DataBeanProperties.IDReporter ? `${element.DataBeanProperties.AccountReporterNit ?? "S/D"} - ${element.DataBeanProperties.AccountReporterFullName ?? ""}` : "N/P";
                    element.DataBeanProperties.SolverEntity = element.DataBeanProperties.IDSolver ? `${element.DataBeanProperties.AccountSolverNit ?? "S/D"} - ${element.DataBeanProperties.AccountSolverFullName ?? ""}` : "N/A";
                    element.DataBeanProperties.StatusEntity = element.DataBeanProperties.IDWorkActivityStatuses ? `${element.DataBeanProperties.StatusesName} (${element.DataBeanProperties.StatusesCategory})` : "N/A";
                    element.DataBeanProperties.Progress = renderSubtaskInfo(element);
                    element.DataBeanProperties.AsignedGroups = renderGroupsListInfo(element.DataBeanProperties.Groups);
                });
                setLista(resp.List);
            }
        ).catch(err => { toast.error(err) })
    }

    const search = () => {
        setAppliedFilters(filters);
        paginador.setPage(1);
        getLista(filters, 1);
    }

    const clearFilters = () => {
        const cleanFilters = {};
        setFilters(cleanFilters);
        setAppliedFilters(cleanFilters);
        paginador.setPage(1);
        getLista(cleanFilters, 1);
    }

    const create = () => {
        setBean({
            State: 1,
            IDReporter: _single.getAccountID(),
        });
        modal.open("Agregar Tarea");
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateWorkActivity(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDWorkActivity', visible: true },
        { title: 'Actividad', property: 'EntityActivity', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Estado', property: 'StatusEntity', visible: true },
        { title: 'Prioridad', property: 'PriorityName', visible: true },
        { title: 'Progreso', property: 'Progress', visible: true },
        { title: 'Grupos', property: 'AsignedGroups', visible: true },
        { title: 'Usuario Asignado', property: 'EmployeEntity', visible: true },
        { title: 'Vencimiento', property: 'DefeatDate', visible: true },
        { title: 'Fecha de Reporte', property: 'Since', visible: true },
        { title: 'Reportador', property: 'ReporterEntity', visible: true },
        { title: 'Fecha de inicio', property: 'FromDate', visible: true },
        { title: 'Solucionado por', property: 'SolverEntity', visible: true },
        { title: 'Fecha de finalización', property: 'UptoDate', visible: true },
        { title: 'Tipo de Tarea', property: 'ActivityTypeName', visible: true },
        { title: 'Clasificación', property: 'TaskTypeName', visible: true },
        { title: 'Periodo de Trabajo', property: 'SprintName', visible: true },
        { title: 'Proyecto Asociado', property: 'ProjectName', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar Actividad ${bean.Name}`); } },
            // { titulo: 'Grupos de Trabajo Asignados', icono: 'ri-group-2-fill', visible: _single.canEdit(), evento: () => { modalTeams.open(); } },
            { titulo: 'Subtareas', icono: 'ri-list-check-2', visible: _single.canEdit(), evento: () => { modalSubWorks.open(`Subtareas de ${bean.EntityActivity}`); } },
            { titulo: 'Notas Adjuntas', icono: 'ri-chat-smile-3-line', visible: true, evento: () => { modalNotes.open(`Notas de ${bean.EntityActivity}`); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo={"Tareas de la entidad"}>
            <div className="row">
                <div className="col-md-4 mb-2">
                    <SelectProject
                        idSelector={filters.IDProject}
                        onChange={(e) => { setFilters({ ...filters, IDProject: e }) }}
                        label="Proyecto"
                    />
                </div>

                <div className="col-md-4 mb-2">
                    <EditorSprint
                        idSelector={filters.IDSprint}
                        onChange={(e) => { setFilters({ ...filters, IDSprint: e.IDSprint }) }}
                        label="Periodo de Trabajo"
                        filterByState={false}
                    />
                </div>

                <div className="col-md-4 mb-2">
                    <AccountEditor
                        idAccount={filters.IDEmployee}
                        label="Usuario Asignado"
                        onChange={(e) => { setFilters({ ...filters, IDEmployee: e.IDAccount }) }}
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <label>Prioridad</label>
                    <SelectWorkActivityPriority
                        label=" "
                        idSelector={filters.IDWorkActivityPriority}
                        onChange={(e) => { setFilters({ ...filters, IDWorkActivityPriority: e }) }}
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <label>Tipo de Tarea</label>
                    <SelectWorkActivityType
                        label=" "
                        idSelector={filters.IDWorkActivityType}
                        onChange={(e) => { setFilters({ ...filters, IDWorkActivityType: e }) }}
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <label>Clasificación</label>
                    <SelectWorkActivityTaskType
                        label=" "
                        idSelector={filters.IDWorkActivityTaskType}
                        onChange={(e) => { setFilters({ ...filters, IDWorkActivityTaskType: e }) }}
                    />
                </div>

                <div className="col-md-3 mb-2">
                    <label>Estado</label>
                    <SelectWorkActivityStatuses
                        label=" "
                        idSelector={filters.IDWorkActivityStatuses}
                        onChange={(e) => { setFilters({ ...filters, IDWorkActivityStatuses: e }) }}
                    />
                </div>

                <div className="col-md-12 mb-3 d-flex gap-2">
                    <BasicButton
                        icon="ri-search-line"
                        eventClick={search}
                        children="Buscar"
                    />
                    <BasicButton
                        icon="ri-eraser-line"
                        eventClick={clearFilters}
                        children="Limpiar"
                        clase="light"
                    />
                </div>

                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} records={paginador} />

                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Nombre de la Tarea</label>
                                <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Codigo de la Tarea</label>
                                <input type="text" className="form-control" value={bean.WorkActivityCode} onChange={(e) => { setBean({ ...bean, WorkActivityCode: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate label="Fecha de Inicio" name="" value={bean.FromDate} setDate={(e) => { setBean({ ...bean, FromDate: e }) }} withTime />
                            </div>
                            <div className="col-md-6">
                                <InputDate label="Fecha de Vencimiento" name="" value={bean.DefeatDate} setDate={(e) => { setBean({ ...bean, DefeatDate: e }) }} withTime />
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-6">
                                        <SelectWorkActivityGroup label="Areas Disponibles" idSelector={bean.IDWorkActivityGroup} onChange={(e) => { setBean({ ...bean, IDWorkActivityGroup: e }) }} />
                                    </div>
                                    {bean.IDWorkActivityGroup &&
                                        <div className="col-md-6">
                                            <SelectWorkActivityGroupUserByIDAccount label="Responsable" idGroup={bean.IDWorkActivityGroup} idSelector={bean.IDEmployee} onChange={(e) => { setBean({ ...bean, IDEmployee: e }) }} />
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label>Estado</label>
                                <SelectWorkActivityStatuses label=" " idSelector={bean.IDWorkActivityStatuses} onChange={(e) => { setBean({ ...bean, IDWorkActivityStatuses: e.IDWorkActivityStatuses, StatusesFinished: e.IsDone }) }} returnType="Object" />
                            </div>
                            {bean.StatusesFinished &&
                                <>
                                    <div className="col-md-6">
                                        <AccountEditor idAccount={bean.IDSolver} label="Solucionado Por" onChange={(e) => { setBean({ ...bean, IDSolver: e.IDAccount }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <InputDate label="Fecha de Finalización" name="" value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, UptoDate: e }) }} withTime />
                                    </div>
                                </>
                            }
                            <div className="col-md-6">
                                <label>Prioridad</label>
                                <SelectWorkActivityPriority label=" " idSelector={bean.IDWorkActivityPriority} onChange={(e) => { setBean({ ...bean, IDWorkActivityPriority: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tipo de Tarea</label>
                                <SelectWorkActivityType label=" " idSelector={bean.IDWorkActivityType} onChange={(e) => { setBean({ ...bean, IDWorkActivityType: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Clasificación</label>
                                <SelectWorkActivityTaskType label=" " idSelector={bean.IDWorkActivityTaskType} onChange={(e) => { setBean({ ...bean, IDWorkActivityTaskType: e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC.modal} updateModal={modalC.setModal} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>

                    <Modal modal={modalNotes.modal} updateModal={modalNotes.setModal}>
                        <WorkActivityNotes WorkActivity={bean} canUse />
                    </Modal>

                    <Modal modal={modalSubWorks.modal} updateModal={modalSubWorks.setModal}>
                        <WorkActivitySubtask WorkActivity={bean} />
                    </Modal>

                </div>
            </div>
        </BasicPage>
    );
}
